import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-widget__item__remove" }
const _hoisted_2 = {
  class: "col-12 col-xl",
  ref: "colLeft"
}
const _hoisted_3 = { class: "cart-widget__items__item__title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "fs-regular"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "row gx-0 gy-2" }
const _hoisted_10 = { class: "col-12 col-lg-auto" }

import {
  PropType,
} from 'vue';
import { useStore } from 'vuex';
import { Product } from '@/classes';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartItemRemove',
  props: {
  itemKey: {
    type: String,
    required: true,
  },
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  isOrderCancel: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['clear', 'approved'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const onApprove = () => {
  store.dispatch('cart/remove', {
    key: props.itemKey,
    product: props.product,
  })
    .then(() => {
      emit('approved');
    });
};

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: __props.product.name
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(_component_BaseSpacer),
      (!__props.isOrderCancel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode(" Das Produkt ")),
            _createElementVNode("i", {
              innerHTML: __props.product.name
            }, null, 8, _hoisted_6),
            _cache[2] || (_cache[2] = _createTextVNode(" aus Ihrem Warenkorb entfernen? "))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _cache[3] || (_cache[3] = _createTextVNode(" Das Produkt ")),
            _createElementVNode("i", {
              innerHTML: __props.product.name
            }, null, 8, _hoisted_8),
            _cache[4] || (_cache[4] = _createTextVNode(" aus Ihrem Warenkorb entfernen und die aktuelle Bestellung abbrechen? "))
          ])),
      _createVNode(_component_BaseSpacer),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('clear'))),
            class: "btn btn-outline-dark btn-sm w-100"
          }, " Nein ")
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 col-lg" }, null, -1)),
        _createElementVNode("div", { class: "col-12 col-lg-auto" }, [
          _createElementVNode("button", {
            onClick: onApprove,
            class: "btn btn-primary btn-sm w-100"
          }, " Ja ")
        ])
      ])
    ], 512)
  ]))
}
}

})